"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidPredicateDefinitionError = void 0;
const PredicateStringParsingError_1 = require("./PredicateStringParsingError");
class InvalidPredicateDefinitionError extends PredicateStringParsingError_1.PredicateStringParsingError {
    constructor(predicateDefinition) {
        super(`${predicateDefinition} is not a valid predicate definition.`);
    }
}
exports.InvalidPredicateDefinitionError = InvalidPredicateDefinitionError;
//# sourceMappingURL=InvalidPredicateDefinitionError.js.map